/** @jsx jsx */
// External libraries
import { LoadingSpinner } from '@checkout/react-components';
import { CacheProvider, css, Global, jsx } from '@emotion/core';

// Internal modules
import { features, getContent, getGlobals, isRtlLang } from '@/lib';
import { globalStyles, resetStyles } from '@/styles';
import { StyledText } from '../Common';
import { EMOTION_CACHE } from './constants';
import {
  MerchantLogo as Logo,
  MerchantLogoContainer,
  ShieldValuePropImg,
  ValuePropContainer,
} from './StyledComponents';
import { valuePropHeaderStyles, valuePropSubHeaderStyles } from './styles';

const EmotionWrapper = ({ children }) => {
  const emotionCacheKey = isRtlLang() ? 'rtl' : 'ltr';

  return (
    <CacheProvider value={EMOTION_CACHE[emotionCacheKey]}>
      <Global styles={[resetStyles, globalStyles]} />
      {children}
    </CacheProvider>
  );
};

const PageLoadingSpinner = () => (
  <LoadingSpinner overlayStyleOverrides={css({ backgroundColor: '#fff' })} />
);

const PayPalValueProps = () => (
  <ValuePropContainer>
    <ShieldValuePropImg />
    <StyledText css={valuePropHeaderStyles}>
      {getContent('valueProps.image.header')}
    </StyledText>
    <StyledText css={valuePropSubHeaderStyles}>
      {getContent('valueProps.image.subHeader')}
    </StyledText>
  </ValuePropContainer>
);

const MerchantLogo = () => {
  const { initialGqlData } = getGlobals();

  const shouldLoadMerchantLogo = Boolean(
    features.isActive('hasMerchantLogo') &&
      initialGqlData?.checkoutSession?.merchant?.logo?.href,
  );

  if (!shouldLoadMerchantLogo) {
    return null;
  }

  return (
    <MerchantLogoContainer>
      <Logo src={initialGqlData?.checkoutSession?.merchant?.logo?.href} />
    </MerchantLogoContainer>
  );
};

export { EmotionWrapper, MerchantLogo, PageLoadingSpinner, PayPalValueProps };
